import { RuleObject } from 'antd/lib/form';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import i18n from '~/i18n';
import { basicValidation } from './basicValidation';

export type Validator = RuleObject['validator'];

const emiratesIdValidation: Validator = basicValidation((rule, formattedEmiratesId, callback) => {
  try {
    const emiratesId = formattedEmiratesId.split('-').join('');
    digitsOnly(emiratesId);
    if (!emiratesId.startsWith('784')) {
      throw new Error((i18n.t('Must starts with {{countryCode}}', { countryCode: '784' })));
    }
    equalLength(15)(emiratesId);
    if (!luhnAlgorithm(emiratesId)) {
      throw new Error(i18n.t('Impossible Emirates ID. Check for typos carefully'));
    }
    callback();
  } catch (err) {
    console.log((err as any).message as string);
    callback((err as any).message as string);
  }


});

const luhnAlgorithm = (emiratesId: string) => {

  const value = emiratesId.replace(/\D/g, '');

  let nCheck = 0;
  let bEven = false;

  for (let n = value.length - 1; n >= 0; n--) {
    let nDigit = parseInt(value.charAt(n), 10);

    if (bEven) {
      nDigit *= 2;
      if (nDigit > 9) {
        nDigit -= 9;
      }
    }

    nCheck += nDigit;
    bEven = !bEven;
  }

  return nCheck % 10 === 0;
}

function digitsOnly(emiratesId: string) {
  isString(emiratesId);
  if (!/^\d+$/.test(emiratesId)) {
    throw new Error(i18n.t('Must contain digits only'));
  }
  return true;
}

function isString(value: string) {
  if (typeof value !== 'string') {
    throw new Error(i18n.t('Must be a string'));
  }
  return true;
}

function equalLength(len: number) {
  const lengthCheck =  (value: any) => {
    isString(value);
    if (value.length !== len) {
      throw new Error( len === 1
        ? i18n.t('Must be {{count}} character', { count: len })
        : i18n.t('Must be {{count}} characters', { count: len }));
    }
    return true;
  };
  return lengthCheck;
}

export default emiratesIdValidation;